/**
 * Created by asiulik on 30.06.2017.
 */

define(['jquery'], function($){

    var $content = $('#content');

    return function (url, animationConfig, $link) {

        var _this = this;
        _this.preloader.show();

        $content.html(this.customAnimationData.$content.html());

        _.delay(function () {

            _this.emit('getPageDone');
            _this.preloader.hide();

            _.delay(function () {

            }, 50)

        }, 1000)

    }

});



// WEBPACK FOOTER //
// ./Private/Scripts/core/page/changePageAnimations/changePageThemenFinder.js